module.exports = __webpack_public_path__ + "img/q2.6f1ef59e.svg";